import React, { useEffect, useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import ViewProfileAccordion from "./viewProfileAccordion";
import ViewBatAccordion from "./viewBatAccordion";

function BatAccordion({ profilesData }) {
	return (
		<div className="profile-accordion">
			<Accordion defaultActiveKey="0">
				{profilesData?.map((item, index) => {
					return (
						<Accordion.Item eventKey={index}>
							<Accordion.Header>
								<div className="d-flex justify-content-between align-items-center w-100">
									<div className="d-flex gap-3 align-items-center justify-content-between w-100">
										<h6 className="fw-700">
											<span>
												{item?.relationship_id == 8 && "Spouse"}
												{item?.relationship_id == 1 && "Son"}
												{item?.relationship_id == 2 && "Daughter"}
											</span>
											:{" "}
											<span>
												{item?.first_name} {item?.middle_name} {item?.last_name}
											</span>
										</h6>
									</div>
								</div>
							</Accordion.Header>
							<Accordion.Body className="toggle-profile-data-grid-responive-body">
								<ViewBatAccordion profileData={item} />
							</Accordion.Body>
						</Accordion.Item>
					);
				})}
			</Accordion>
		</div>
	);
}

export default BatAccordion;
